import {
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
} from "@mui/material";
import { Button } from "components/Button/Button";
import ModalBox from "components/modal/ModalBox";
import useDebounce from "hooks/useDebounce";
import React, { useState } from "react";
import toast from "react-hot-toast";
import Pagination from "react-js-pagination";
import { getCoursesByStudent } from "services/student/studentController";

const CourseModal = ({
  open,
  onClose,
  courseSelectionHandler,
  selectedCourseId,
  userData,
  assignHandler,
}) => {
  const [search, setSearch] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [allCourses, setAllCourses] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const debouncedValue = useDebounce(search, 300);

  const modalOnClose = () => {
    setSearch("");
    onClose();
  };

  //   get all courses
  const getAllCourses = async (page = activePage, search = debouncedValue) => {
    setLoading(true);
    try {
      const res = await getCoursesByStudent({
        studentId: userData?.UserID,
        page,
        search,
      });

      if (res.code === 200) {
        setAllCourses(res.data.userCourses || []);
        setTotal(res.data.count || 0);
        setLoading(false);
      } else {
        toast.error(res.message);
        setLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (open) {
      getAllCourses();
    }
    // eslint-disable-next-line
  }, [debouncedValue, open, activePage]);

  return (
    <>
      <ModalBox
        size={"sm"}
        status={open}
        onClose={modalOnClose}
        title={`Assign Course`}
        custom
        customizedFooter={
          <div>
            <Button onClick={modalOnClose} className="mx-3">
              Close
            </Button>
            <Button onClick={assignHandler} className="mx-3">
              Assign
            </Button>
          </div>
        }
      >
        <div className="form-group mt-1 row">
          <div className="div_wrap my-3">
            <input
              type="text"
              placeholder="Search"
              className="form-control"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/*  loading section */}
          {loading && <LinearProgress />}

          {/* course list section */}
          {!loading && (
            <div className="TableList overflow-auto table-responsive py-0">
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
              >
                {allCourses.length > 0 ? (
                  allCourses.map(({ CourseID, CourseTitle }, i) => (
                    <ListItem key={CourseID} disablePadding className="border">
                      <ListItemButton
                        role={undefined}
                        onClick={() => courseSelectionHandler(CourseID)}
                        dense
                      >
                        <ListItemIcon>
                          <Radio
                            edge="start"
                            checked={selectedCourseId === CourseID}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": CourseID }}
                          />
                        </ListItemIcon>
                        <ListItemText id={CourseID} primary={CourseTitle} />
                      </ListItemButton>
                    </ListItem>
                  ))
                ) : (
                  <ListItem disablePadding>
                    <ListItemButton
                      role={undefined}
                      // onClick={handleToggle(value)}
                      dense
                    >
                      <h5 className="w-100 text-center">
                        Entries Not Available
                      </h5>
                    </ListItemButton>
                  </ListItem>
                )}
              </List>
              {total > 10 ? (
                <div className="Pagination d-flex justify-content-center m-0">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(page) => setActivePage(page)}
                  />
                </div>
              ) : null}
            </div>
          )}
        </div>
      </ModalBox>
    </>
  );
};

export default CourseModal;
